var _rect, _rect2, _rect3, _rect4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddcontent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "url(#paint0_linear_3954_1890)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "url(#paint1_linear_3954_1890)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "url(#paint2_linear_3954_1890)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "url(#paint3_linear_3954_1890)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3954_1890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 18.2C16 17.6165 16.2318 17.0569 16.6444 16.6444C17.0569 16.2318 17.6165 16 18.2 16H28.2C28.7835 16 29.3431 16.2318 29.7556 16.6444C30.1682 17.0569 30.4 17.6165 30.4 18.2V23.2176C30.026 22.9778 29.6227 22.7872 29.2 22.6504V18.2C29.2 17.648 28.752 17.2 28.2 17.2H18.2C17.648 17.2 17.2 17.648 17.2 18.2V28.2C17.2 28.752 17.648 29.2 18.2 29.2H22.6504C22.7888 29.6272 22.98 30.0296 23.2176 30.4H18.2C17.6165 30.4 17.0569 30.1682 16.6444 29.7556C16.2318 29.3431 16 28.7835 16 28.2V18.2ZM32 27.6C32 26.433 31.5364 25.3139 30.7113 24.4887C29.8861 23.6636 28.767 23.2 27.6 23.2C26.433 23.2 25.3139 23.6636 24.4887 24.4887C23.6636 25.3139 23.2 26.433 23.2 27.6C23.2 28.767 23.6636 29.8861 24.4887 30.7113C25.3139 31.5364 26.433 32 27.6 32C28.767 32 29.8861 31.5364 30.7113 30.7113C31.5364 29.8861 32 28.767 32 27.6ZM28 28L28.0008 30.0024C28.0008 30.1085 27.9587 30.2102 27.8836 30.2852C27.8086 30.3603 27.7069 30.4024 27.6008 30.4024C27.4947 30.4024 27.393 30.3603 27.318 30.2852C27.2429 30.2102 27.2008 30.1085 27.2008 30.0024V28H25.1968C25.0907 28 24.989 27.9579 24.914 27.8828C24.8389 27.8078 24.7968 27.7061 24.7968 27.6C24.7968 27.4939 24.8389 27.3922 24.914 27.3172C24.989 27.2421 25.0907 27.2 25.1968 27.2H27.2V25.2C27.2 25.0939 27.2421 24.9922 27.3172 24.9172C27.3922 24.8421 27.4939 24.8 27.6 24.8C27.7061 24.8 27.8078 24.8421 27.8828 24.9172C27.9579 24.9922 28 25.0939 28 25.2V27.2H29.9976C30.1037 27.2 30.2054 27.2421 30.2804 27.3172C30.3555 27.3922 30.3976 27.4939 30.3976 27.6C30.3976 27.7061 30.3555 27.8078 30.2804 27.8828C30.2054 27.9579 30.1037 28 29.9976 28H28Z",
    fill: "#FFD119"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3954_1890",
    x1: 3.95122,
    y1: 50.6341,
    x2: 50.1951,
    y2: -3.21951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#FFD119",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3954_1890",
    x1: 47.8537,
    y1: -6.14634,
    x2: 3.95122,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#FFD119",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3954_1890",
    x1: 2.08064,
    y1: 8.03226,
    x2: 41.8548,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#FFD119",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3954_1890",
    x1: 49.1129,
    y1: 50.129,
    x2: 7.30645,
    y2: 20.5161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#FFD119",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3954_1890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddcontent);
export default __webpack_public_path__ + "static/media/addcontent.b425360896f83af3bf8342e8ffa52756.svg";
export { ForwardRef as ReactComponent };